module.exports = __webpack_public_path__ + "static/media/1_pl.eaae03f5.png";